import { createContext, useContext } from 'react';

import type { CsvImporterConfig, CsvMapping } from '@/components/common/CsvImporter/csvImporter.helpers';
import type { DataProcessResult, UploadData } from '../types';

export interface LocationCSVUploadModalContextProps {
  config: CsvImporterConfig;
  country?: string;
  file?: File;
  mapping: CsvMapping[];
  preprocess?: DataProcessResult;
  preprocessStatus: DataProcessResult['status'];
  setConfig: (config: CsvImporterConfig) => void;
  setCountry: (country: string) => void;
  setFile: (file?: File) => void;
  setMapping: (mapping: CsvMapping[]) => void;
  uploadedFile: UploadData;
  uploadedFileStatus: DataProcessResult['status'];
}

export const LocationCSVUploadModalContext = createContext<LocationCSVUploadModalContextProps>(
  {} as LocationCSVUploadModalContextProps
);

LocationCSVUploadModalContext.displayName = 'LocationCSVUploadModalContext';

export function useLocationCSVUploadModalContext(): LocationCSVUploadModalContextProps {
  const context = useContext(LocationCSVUploadModalContext);
  if (!context) {
    throw new Error('useLocationCSVUploadModalContext cannot be used outside LocationCSVUploadModalProvider');
  }
  return context;
}
